module.exports = __webpack_public_path__ + "img/Terraform-Inspect-Large.52498e0b.png";